import { render, staticRenderFns } from "./campus-event-modal.vue?vue&type=template&id=c10883b0&scoped=true"
import script from "./campus-event-modal.vue?vue&type=script&lang=js"
export * from "./campus-event-modal.vue?vue&type=script&lang=js"
import style0 from "./campus-event-modal.vue?vue&type=style&index=0&id=c10883b0&prod&scoped=true&lang=css"
import style1 from "./campus-event-modal.vue?vue&type=style&index=1&id=c10883b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10883b0",
  null
  
)

export default component.exports